var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bubble-loader"},[_c('div',{staticClass:"bubble"}),_c('div',{staticClass:"bubble"}),_c('div',{staticClass:"bubble"})])
}]

export { render, staticRenderFns }